import { render, staticRenderFns } from "./AddIpsForWhitelist.vue?vue&type=template&id=c219a54c&scoped=true"
import script from "./AddIpsForWhitelist.vue?vue&type=script&lang=js"
export * from "./AddIpsForWhitelist.vue?vue&type=script&lang=js"
import style0 from "./AddIpsForWhitelist.vue?vue&type=style&index=0&id=c219a54c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c219a54c",
  null
  
)

export default component.exports